import { Button, Card, Form, Input, message } from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from '@/services/api.service';
import EducationPageChrome from '@/pages/education/components/EducationPageChrome';

type ApiError = { response?: { data?: { message?: string } } };

export default function AcademicSessionFormPage() {
  const { t } = useTranslation('education');
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const save = useMutation({
    mutationFn: (values: { code: string; name: string; start_date: string; end_date: string }) =>
      api.post<{ id: string }>('/education/academic/sessions', values),
    onSuccess: (result) => {
      queryClient.invalidateQueries({ queryKey: ['education-academic-sessions'] });
      message.success(t('sessionSaved'));
      navigate(`/education/academic/sessions/${result.data?.id}`);
    },
    onError: (error: ApiError) => {
      message.error(error.response?.data?.message || t('unavailable', { status: '' }));
    },
  });

  return (
    <EducationPageChrome
      title={t('newSession')}
      description={t('academicIntro')}
      extra={<Button onClick={() => navigate('/education/academic')}>{t('backToAcademic')}</Button>}
    >
      <Card size="small">
        <Form layout="vertical" onFinish={(values) => save.mutate(values)} style={{ maxWidth: 480 }}>
          <Form.Item name="code" label={t('sessionCode')} rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="name" label={t('sessionName')} rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="start_date" label={t('startDate')} rules={[{ required: true }]}>
            <Input placeholder="2026-04-01" />
          </Form.Item>
          <Form.Item name="end_date" label={t('endDate')} rules={[{ required: true }]}>
            <Input placeholder="2027-03-31" />
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={save.isPending}>
            {t('save')}
          </Button>
        </Form>
      </Card>
    </EducationPageChrome>
  );
}
